module.exports = __webpack_public_path__ + "img/xmasParty5.476231a9.jpg";